import { Box, Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledSubMenuContainer = styled(Box)(({ theme }) => ({
  paddingInline: `${theme.spacing(8)} !important`,
  [theme.breakpoints.up('xl')]: {
    paddingInline: `${theme.spacing(20)} !important`,
  },
  [theme.breakpoints.up('gs')]: {
    paddingInline: `${theme.spacing(20)} !important`,
    width: 2600,
    marginInline: 'auto',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    overflow: 'visible',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100vw',
      height: '1px',
      backgroundColor: theme.palette.background.contrast,
    },
  },
  width: '100%',
  maxHeight: theme.spacing(105),
  backgroundColor: theme.palette.background.default,
  border: '1px solid',
  borderColor: theme.palette.background.contrast,
  boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(30px)',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gridTemplateRows: '1fr',
  gap: theme.spacing(6),
  position: 'absolute',
  top: theme.spacing(19),
  left: 0,
  right: 0,
  zIndex: theme.zIndex.tooltip - 1,
  overflow: 'hidden',
}));

export const StyledMenuInfoSection = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'start',
  padding: theme.spacing(3.75),
  paddingRight: theme.spacing(6),
  borderRight: '6px solid',
  borderColor: theme.palette.background.contrast,
  overflow: 'hidden',
}));

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  maxHeight: theme.spacing(20),
  maxWidth: theme.spacing(27.5),
  marginTop: theme.spacing(10.375),
  marginBottom: theme.spacing(6),
}));

export const StyledMenuTitle = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(42),
  fontWeight: 700,
  fontStyle: 'italic',
  marginBottom: theme.typography.pxToRem(16),
  minHeight: theme.typography.pxToRem(63),
  color: theme.palette.text.second,
}));

export const StyledMenuDescription = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 400,
  height: 100,
}));

export const StyledMenuItemsContainer = styled(Box)({
  alignSelf: 'center',
});

interface StyledMenuItemRowProps {
  isActive?: boolean;
}

export const StyledMenuItemRow = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StyledMenuItemRowProps>(({ theme, isActive }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.typography.pxToRem(10),
  maxWidth: theme.spacing(134),
  backgroundColor: isActive ? theme.palette.secondary.main : 'transparent',
}));

export const StyledMenuItemLabel = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 400,
  color: theme.palette.text.main,
  padding: theme.spacing(3, 4),
}));

export const StyledBannerContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
